import {applySnapshot, types as t,} from 'mobx-state-tree';

export const initialRateStore = {
    currency: 'MXN',
    rates: {
        USD: 1,
        MXN: 0,
        EUR: 0,
        KZT: 0,
        VND: 0,
    }
};

export const RateStore = t
    .model({
        currency: t.string,
        rates: t.model({
            MXN: t.number,
            USD: t.number,
            EUR: t.number,
            KZT: t.number,
            VND: t.number,
        })
    })
    .views((self) => ({
        // @ts-ignore
        currencyRate: () => self.rates[self.currency]
    }))
    .actions((self) => ({
        clearState: () => {
            applySnapshot(self, initialRateStore);
        },
        setCurrency: (currency: string) => {
            self.currency = currency;
        },
        setRate: (MXN: number, USD: number, EUR: number, KZT: number, VND: number) => {
            self.rates = {
                MXN,
                USD,
                EUR,
                KZT,
                VND,
            }
        }
    }));
